import { Skeleton } from "@/components/ui/skeleton";

export function ContractsLoadingComponent({
  tickbox = true,
}: {
  tickbox?: boolean;
}) {
  return (
    <div
      aria-label="Loading contracts"
      className="space-y-2 py-1"
      role="status"
      data-testid="contracts-loading"
    >
      {[0, 1].map((item) => (
        <div className="flex items-center gap-2" key={item}>
          {tickbox && <Skeleton className="h-4 w-4 rounded-sm" />}
          <Skeleton className="h-4 w-3/4" />
        </div>
      ))}
    </div>
  );
}
